import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import buySteps from "../buySteps";

const SelectionBuyOwnAppStep_3 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    return goToStep(buySteps.selectionSteps.step_2);
  };

  const handleYestStep = () => {
    return goToStep(buySteps.selectionSteps.swap.step_1);
  };

  const handleNotStep = () => {
    return goToStep(buySteps.selectionSteps.buy.step_1);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        yesStep={handleYestStep}
        noStep={handleNotStep}
        text={"Хотите продать текущую квартиру для покупки новой?"}
      />
    </div>
  );
};

export default SelectionBuyOwnAppStep_3;
